// BOF: Deva
/*
 * Angepinntes Produkt fuer Collection-Seiten (siehe sections/main-collection.liquid).
 *
 * Globo Smart Product Filter rendert das Produktgrid im Browser neu (#gf-products) und ersetzt dabei den
 * Inhalt komplett. Nach jedem Render setzen wir die serverseitig vorbereitete Karte auf Seite 1 vorne ein,
 * sofern keine Filter, keine Suche und die Standardsortierung aktiv sind.
 *
 * Abhaengig von Globo-Interna (Stand smart-product-filters-1092):
 * - Event "globoFilterRenderCompleted" auf window
 * - Grid-Container #gf-products
 * - Zustand in history.state.queryParams (wird erst nach dem Event gesetzt)
 * - Globo-Karten tragen handle="<handle> edit"
 * Aendert sich davon etwas, wird einfach nicht gepinnt - das Grid selbst bleibt unberuehrt.
 */
(() => {
  const template = document.getElementById('pinned-product-template');
  if (!template) return;

  const handle = template.dataset.handle;

  const isDefaultView = (state) => {
    const defaultSort = window.GloboEmbedFilterConfig?.collection?.sort;
    const hasFilter = state.filter && Object.keys(state.filter).length > 0;

    return !state.q && !hasFilter && (!state.sort_by || state.sort_by === defaultSort);
  };

  const apply = () => {
    const grid = document.getElementById('gf-products');
    const state = history.state?.queryParams;
    if (!grid || !state) return;

    grid.querySelectorAll(':scope > [data-pinned-product]').forEach((card) => card.remove());

    if (!isDefaultView(state)) return;

    // Liegt das Produkt selbst in der Collection, liefert Globo es ebenfalls - dort entfernen
    grid.querySelectorAll(`:scope > product-card[handle~="${handle}"]`).forEach((card) => card.remove());

    if (Number(state.page || 1) === 1) {
      const card = template.content.firstElementChild.cloneNode(true);
      card.setAttribute('data-pinned-product', '');
      grid.prepend(card);
    }
  };

  // Globo aktualisiert history.state erst direkt nach dem Event, daher einen Microtask spaeter pruefen
  window.addEventListener('globoFilterRenderCompleted', () => queueMicrotask(apply));

  // Falls Globo schon vor diesem Script gerendert hat
  apply();
})();
// EOF: Deva
